import { styled, Tab } from '@mui/material';

export const TabStyled = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'nTabs',
})(({ theme, variant, nTabs }) => ({
  width: variant === 'innerTabs' ? 185 : `calc(100% / ${nTabs})`,
  color: theme.palette.colors.lower,
  fontSize: '14px',
  fontWeight: 500,
  maxHeight: 34,
  minHeight: 34,
  padding: 0,
  position: 'static',

  '&.Mui-selected': {
    fontWeight: 'bold',
    color: theme.palette.colors.mainFocused,
    marginBottom: 5,
  },
  '&:hover': {
    fontWeight: 'bold',
    marginBottom: 5,
    '& span': {
      visibility: 'visible',
    },
  },
  '&:disabled': {
    color: theme.palette.colors.lower,
  },
  [theme.breakpoints.between('xxl', 'xxxl')]: {
    width: variant === 'innerTabs' && 159,
  },
  [theme.breakpoints.between('xl', 'xxl')]: {
    width: variant === 'innerTabs' && 141,
  },
  [theme.breakpoints.between('lg', 'xl')]: {
    width: variant === 'innerTabs' && 135,
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '16px',
  },

  [theme.breakpoints.down('md')]: {
    width: variant === 'innerTabs' && '172px',
  },

  [theme.breakpoints.down('sm')]: {
    width: variant === 'innerTabs' && '120px',
    '&.Mui-selected': {
      color: theme.palette.colors.mainFocused,
      fontWeight: 'bold',
    },
  },
}));

export const SpanStyled = styled('span', {
  shouldForwardProp: (prop) =>
    prop !== 'variant' &&
    prop !== 'tabWidth' &&
    prop !== 'textColor' &&
    prop !== 'selectionFollowsFocus' &&
    prop !== 'fullWidth' &&
    prop !== 'indicator',
})(({ theme, variant, tabWidth }) => ({
  visibility: 'hidden',
  width: variant === 'innerTabs' ? 185 : tabWidth,
  backgroundColor: theme.palette.colors.highlight,
  height: '5px',
  position: 'absolute',
  marginBottom: -39,

  '&.MuiTabs-indicator': {
    bottom: 'auto !important',
  },

  [theme.breakpoints.between('xxl', 'xxxl')]: {
    width: variant === 'innerTabs' && 159,
  },
  [theme.breakpoints.between('xl', 'xxl')]: {
    width: variant === 'innerTabs' && 141,
  },
  [theme.breakpoints.between('lg', 'xl')]: {
    width: variant === 'innerTabs' && 135,
  },
}));
